import { useEffect, useState } from "react";
import { getConsentOK, saveConsentOK } from "../utils/consent";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsentOK()) setVisible(true);
  }, []);

  const onOk = () => {
    saveConsentOK();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-5xl rounded-t-2xl border border-neutral-800 bg-black/80 backdrop-blur px-4 py-4">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="text-sm text-neutral-200">
            We use only <strong>essential cookies</strong> to make this site work.
            See our{" "}
            <a className="underline" href="/privacy">
              Privacy Policy
            </a>{" "}
            and{" "}
            <a className="underline" href="/cookies">
              Cookie Policy
            </a>
            .
          </p>

          <div className="flex gap-2 shrink-0">
            <button
              onClick={onOk}
              className="px-4 py-2 rounded-xl bg-white text-black text-sm font-bold hover:opacity-90"
              aria-label="OK, got it"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
